module.exports = __webpack_public_path__ + "static/media/upsell-benefit-portals.f20d47a9.svg";